// extracted by mini-css-extract-plugin
export var root = "PrismTheme-module--root--2bVgC";